// Additional labels for the merchant UI. Agreement text remains unchanged.
const redesign = {
  Yes: "Sí",
  No: "No",
  Name: "Nombre",
  "Average Sales Amount is Required": "El importe promedio de venta es obligatorio",
  "Highest Estimated Sales Amount is Required": "El importe máximo estimado de venta es obligatorio",
  "Estimated Monthly Credit and Debit Card Sales is Required": "Las ventas mensuales estimadas con tarjeta son obligatorias",
  "We could not load your saved application. Please refresh to try again.": "No pudimos cargar su solicitud guardada. Actualice la página para volver a intentarlo.",
  "Speak with an application specialist.":
    "Hable con un especialista en solicitudes.",
  "Application navigation": "Navegación de la solicitud",
  "Application progress": "Progreso de la solicitud",
  "Step {current} of {total}": "Paso {current} de {total}",
  "Get Started": "Inicio",
  Business: "Negocio",
  Owner: "Propietario",
  Sales: "Ventas",
  Banking: "Banco",
  Payment: "Pago",
  Review: "Revisión",
  Saving: "Guardando",
  "Submit Application": "Enviar solicitud",
  "Your information is secure.": "Su información está segura.",
  "We use industry-standard encryption to keep your information safe and private.":
    "Usamos cifrado estándar de la industria para mantener su información segura y privada.",
  "This application takes about 5 minutes to complete.":
    "Completar esta solicitud toma aproximadamente 5 minutos.",
  "This email will be used for your merchant statements, important account updates, and logging in to your point of sale. You can use either a personal or business email address.":
    "Usaremos este correo electrónico para sus estados de cuenta de comerciante, avisos importantes sobre su cuenta y para iniciar sesión en su punto de venta. Puede usar un correo personal o del negocio.",
  "Let's start with some basic information about your business.":
    "Comencemos con información básica sobre su negocio.",
  "Your ownership type determines which information is required.":
    "El tipo de propiedad determina qué información se necesita.",
  "Would you like to add an EIN?": "¿Desea agregar un EIN?",
  "Doing Business As (DBA)": "Nombre comercial (DBA)",
  "What year did you open your business?": "¿En qué año abrió su negocio?",
  "Website URL (optional)": "Sitio web (opcional)",
  "Suite, Unit or Apt. (optional)": "Oficina, unidad o departamento (opcional)",
  "Use business address as mailing address":
    "Usar la dirección del negocio como dirección postal",
  "Live Receipt Preview": "Vista previa del recibo",
  "See how your customer receipts will look.":
    "Vea cómo se verán los recibos de sus clientes.",
  "Your Business": "Su negocio",
  "Sample receipt": "Recibo de muestra",
  SALE: "VENTA",
  TOTAL: "TOTAL",
  "Please come again.": "Esperamos verle pronto.",
  "Tell us about the primary owner or authorized representative.":
    "Cuéntenos sobre el propietario principal o representante autorizado.",
  "Mobile Phone Number": "Número de teléfono celular",
  "Change email": "Cambiar correo electrónico",
  "Home Address": "Domicilio particular",
  "Home address is the same as business address":
    "El domicilio particular es el mismo que la dirección del negocio",
  "Secure Identity Verification": "Verificación segura de identidad",
  "Your SSN is used to verify your identity and complete your merchant account application.":
    "Su número de Seguro Social se usa para verificar su identidad y completar la solicitud de su cuenta de comerciante.",
  "SSN saved securely": "Número de Seguro Social guardado de forma segura",
  "Change SSN": "Cambiar número de Seguro Social",
  "Account Information": "Información de la cuenta",
  "A few quick estimates of your credit card sales.":
    "Algunas estimaciones rápidas de sus ventas con tarjeta de crédito.",
  "We ask for these estimates to properly set up your account.":
    "Le pedimos estas estimaciones para configurar correctamente su cuenta.",
  "Exact figures are not required. Just provide your best estimates.":
    "No se necesitan cifras exactas. Proporcione sus mejores estimaciones.",
  "How much does a customer typically spend in a single credit or debit card transaction?":
    "¿Cuánto suele gastar un cliente en una sola transacción con tarjeta de crédito o débito?",
  "What is the largest single credit or debit card transaction you expect to process?":
    "¿Cuál es la transacción más alta con tarjeta de crédito o débito que espera procesar?",
  "About how much do you expect to process in total credit and debit card sales each month?":
    "¿Cuánto espera procesar en total cada mes en ventas con tarjetas de crédito y débito?",
  Amount: "Monto",
  "Banking Information": "Información bancaria",
  "Where should we send your deposits?": "¿Dónde debemos enviar sus depósitos?",
  "Fast, secure deposits": "Depósitos rápidos y seguros",
  "Next-day funding available, subject to approval and processing schedules.":
    "Fondos disponibles al día siguiente, sujetos a aprobación y a los horarios de procesamiento.",
  "9 digits": "9 dígitos",
  "Re-enter Bank Account Number":
    "Vuelva a ingresar el número de cuenta bancaria",
  "Loading order summary": "Cargando el resumen del pedido",
  "We could not calculate the order total. Please try again.":
    "No pudimos calcular el total del pedido. Inténtelo de nuevo.",
  "Try again": "Intentar de nuevo",
  "Review Your Application": "Revise su solicitud",
  "Please review your information. Use Edit to make changes before signing.":
    "Revise su información. Use Editar para hacer cambios antes de firmar.",
  "Business Information": "Información del negocio",
  "Owner Information": "Información del propietario",
  "Bank Account Information": "Información de la cuenta bancaria",
  "Edit sales estimates": "Editar estimaciones de ventas",
  "Not provided": "No proporcionado",
  "Agreements & Signature": "Acuerdos y firma",
  Accepted: "Aceptado",
  "Electronic Signature": "Firma electrónica",
  "Draw your signature with your mouse or finger:":
    "Dibuje su firma con el ratón o con el dedo:",
  "If you edit your application after signing, please sign again when you return.":
    "Si edita su solicitud después de firmar, vuelva a firmar al regresar.",
  "Clear Signature": "Borrar firma",
  "Enter a valid EIN or choose No.": "Ingrese un EIN válido o elija No.",
  "Routing number must contain 9 digits.":
    "El número de ruta bancaria debe tener 9 dígitos.",
  "We could not securely save your SSN. Please try again.":
    "No pudimos guardar su número de Seguro Social de forma segura. Inténtelo de nuevo.",
  "We could not save your application. Please try again.":
    "No pudimos guardar su solicitud. Inténtelo de nuevo.",
  Show: "Mostrar",
  Hide: "Ocultar",
  Edit: "Editar",
  "We will never share or sell your information.":
    "Nunca compartiremos ni venderemos su información.",
  // Business
  "Business Phone Number": "Teléfono del negocio",
  "Example: Kennedy's Cafe": "Ejemplo: Kennedy's Cafe",
  "Example: Restaurant, Retail, Professional Services":
    "Ejemplo: restaurante, comercio minorista, servicios profesionales",
  Recommended: "Recomendado",
  "Use business address for equipment shipping":
    "Usar la dirección del negocio para el envío del equipo",
  "This address will only be used once to ship your equipment. You will receive your equipment within 2-3 business days from approval, ready and programmed to accept credit cards.":
    "Esta dirección se usará solo una vez para enviar su equipo. Recibirá su equipo dentro de 2 a 3 días hábiles después de la aprobación, listo y programado para aceptar tarjetas de crédito.",
  "Equipment Shipping Address": "Dirección de envío del equipo",
  "Shipping Address is Required": "La dirección de envío es obligatoria",
  "Your mailing address is where you will receive all communications for your merchant account, including account information, monthly statements, and important notices.":
    "Su dirección postal es donde recibirá todas las comunicaciones de su cuenta de comerciante, incluida la información de la cuenta, los estados de cuenta mensuales y los avisos importantes.",
  // Principal
  "This information is required to verify your identity and approve your merchant account so you can accept credit and debit cards.":
    "Esta información es necesaria para verificar su identidad y aprobar su cuenta de comerciante para que pueda aceptar tarjetas de crédito y débito.",
  "To approve your merchant account to accept credit and debit cards, our processing partner must verify your identity. This is a standard requirement for all merchant accounts and helps prevent fraud and protect your business.":
    "Para aprobar su cuenta de comerciante y aceptar tarjetas de crédito y débito, nuestro socio de procesamiento debe verificar su identidad. Es un requisito estándar para todas las cuentas de comerciante y ayuda a prevenir el fraude y proteger su negocio.",
  "Bank-level Security": "Seguridad de nivel bancario",
  "Your information is encrypted and transmitted securely.":
    "Su información se cifra y se transmite de forma segura.",
  "Used for Verification Only": "Solo para verificación",
  "Your SSN is used to verify your identity and complete the merchant account approval.":
    "Su SSN se usa para verificar su identidad y completar la aprobación de la cuenta de comerciante.",
  "Trusted Processing Partner": "Socio de procesamiento confiable",
  "We use industry-standard security measures and never share or sell your information.":
    "Usamos medidas de seguridad estándar de la industria y nunca compartimos ni vendemos su información.",
  "Social Security Number (Required)": "Número de Seguro Social (obligatorio)",
  "Confirm Social Security Number": "Confirme el número de Seguro Social",
  "Confirm Social Security Number is Required":
    "La confirmación del número de Seguro Social es obligatoria",
  "Social Security Numbers do not match":
    "Los números de Seguro Social no coinciden",
  "Why is this required?": "¿Por qué se necesita?",
  "When your business accepts credit cards, financial institutions are required to verify the identity of the individuals who own or control the business. Your personal information helps us complete this verification and approve your merchant account.":
    "Cuando su negocio acepta tarjetas de crédito, las instituciones financieras deben verificar la identidad de las personas que son dueñas del negocio o lo controlan. Su información personal nos ayuda a completar esta verificación y aprobar su cuenta de comerciante.",
  // Account
  "These details help us configure your merchant account with the right processing limits and settings. Exact figures are not required. Just provide your best estimates.":
    "Estos datos nos ayudan a configurar su cuenta de comerciante con los límites de procesamiento y los ajustes correctos. No se necesitan cifras exactas. Solo indique sus mejores estimaciones.",
  "These amounts help us determine the appropriate processing limits, configure your account, and monitor for unusual activity for your protection.":
    "Estos montos nos ayudan a definir los límites de procesamiento adecuados, configurar su cuenta y detectar actividad inusual para su protección.",
  "Sets the right processing limits":
    "Define los límites de procesamiento correctos",
  "Helps prevent account disruptions":
    "Ayuda a evitar interrupciones en la cuenta",
  "Protects your account from unusual activity":
    "Protege su cuenta de actividad inusual",
  "Enter amount": "Ingrese el monto",
  // Banking
  "Enter the bank account where you'd like to receive the funds from your credit and debit card sales.":
    "Ingrese la cuenta bancaria donde desea recibir los fondos de sus ventas con tarjetas de crédito y débito.",
  "Your credit card sales will be deposited directly into this bank account, usually the following business day.":
    "Sus ventas con tarjeta se depositarán directamente en esta cuenta bancaria, normalmente el siguiente día hábil.",
  "Next-day funding available (subject to approval and processing schedules)":
    "Fondos al día siguiente disponibles (sujeto a aprobación y a los horarios de procesamiento)",
  "Secure and encrypted transmission": "Transmisión segura y cifrada",
  "Used to set up and process your merchant account":
    "Se usa para configurar y procesar su cuenta de comerciante",
  "Example: Chase, Bank of America, Wells Fargo":
    "Ejemplo: Chase, Bank of America, Wells Fargo",
  "9 digits (e.g. 123456789)": "9 dígitos (p. ej., 123456789)",
  "Enter your account number": "Ingrese su número de cuenta",
  "Confirm your account number": "Confirme su número de cuenta",
  "Your banking information is protected.":
    "Su información bancaria está protegida.",
  "Your banking details are used to set up your merchant account and process deposits.":
    "Sus datos bancarios se usan para configurar su cuenta de comerciante y procesar los depósitos.",
  // Payment
  "The 3-digit code on the back of your card. AMEX cards have a 4-digit code on the front.":
    "El código de 3 dígitos en el reverso de su tarjeta. Las tarjetas AMEX tienen un código de 4 dígitos en el frente.",
  "What is CVV?": "¿Qué es el CVV?",
  // Review
  "Please review all of your information below. If you need to make any changes, click the Edit button next to each section. When everything looks correct, click Submit Application.":
    "Revise toda su información a continuación. Si necesita hacer cambios, haga clic en Editar junto a cada sección. Cuando todo esté correcto, haga clic en Enviar solicitud.",
  "Your business details and contact information.":
    "Datos de su negocio e información de contacto.",
  "Primary owner and personal information.":
    "Propietario principal e información personal.",
  "Where you would like to receive your funds.":
    "Dónde desea recibir sus fondos.",
  "Terms and conditions and your electronic signature.":
    "Términos y condiciones y su firma electrónica."
};
export default redesign;
